export const SCORE_COLORS = {
  red: '#ef4444', // 0-40
  orange: '#f97316', // 40-60
  yellow: '#eab308', // 60-75
  lightGreen: '#84cc16', // 75-90
  darkGreen: '#16a34a', // 90-100
} as const;
